module.exports = __webpack_public_path__ + "img/cancel-hen.25579a78.png";